import { useIntl } from "react-intl";

import { Button } from "@/components/Button/Button";
import { Dialog } from "@/components/Dialog/Dialog";
import { IconFlightService, IconHotelService } from "@/components/Icons";

type Props = {
  open: boolean;
  type: "flight" | "hotel";
  onRefresh: () => void;
  onNewSearch: () => void;
};

export default function SearchExpiredModal({
  open,
  type,
  onRefresh,
  onNewSearch,
}: Props) {
  const intl = useIntl();

  const contentByType = {
    flight: {
      title: intl.formatMessage({
        defaultMessage: "Flight prices may have changed",
        description: "Title for flight search expired modal",
      }),
      body: intl.formatMessage({
        defaultMessage:
          "Refresh the results to see the latest prices and seat availability.",
        description: "Body text for flight search expired modal",
      }),
      Illustration: IconFlightService,
    },
    hotel: {
      title: intl.formatMessage({
        defaultMessage: "Room availability may have changed",
        description: "Title for hotel search expired modal",
      }),
      body: intl.formatMessage({
        defaultMessage:
          "Refresh the results to see the latest options and prices.",
        description: "Body text for hotel search expired modal",
      }),
      Illustration: IconHotelService,
    },
  } as const;

  const { title, body, Illustration } = contentByType[type];

  return (
    <Dialog
      isOpen={open}
      actions={
        <div className="flex w-full gap-4 px-2 pb-2">
          <Button
            variant="contained"
            size="small"
            onClick={onRefresh}
            fullWidth
          >
            {intl.formatMessage({
              defaultMessage: "Refresh results",
              description:
                "Label for refresh results button in search expired modal",
            })}
          </Button>
          <Button
            variant="outlined"
            size="small"
            onClick={onNewSearch}
            fullWidth
          >
            {intl.formatMessage({
              defaultMessage: "New Search",
              description:
                "Label for new search button in search expired modal",
            })}
          </Button>
        </div>
      }
    >
      <div className="flex flex-col items-center gap-4 pt-1">
        <Illustration className="size-18 shrink-0" />
        <div>
          <h2 className="mb-1 text-center text-base font-semibold">{title}</h2>
          <p className="text-center text-sm text-text-placeholder">{body}</p>
        </div>
      </div>
    </Dialog>
  );
}
